<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} {{ titulo }}
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <v-row class="d-flex justify-center mt-4">
              <v-col cols="12">
                <v-text-field
                  v-model="content.nome"
                  :label="'Perfil da Turma em ' + funcionalidade + '*'"
                  dense
                  outlined
                  counter="25"
                  maxlength="25"
                  :rules="[(v) => $required(v)]"
                ></v-text-field>
                <v-select
                  v-model="content.nivelDeEnsino"
                  label="Nível de Ensino*"
                  outlined
                  dense
                  :items="niveisDeEnsino"
                  item-value="id"
                  item-text="descricao"
                  return-object
                  :rules="[(v) => $required(v)]"
                ></v-select>
                <v-select
                  v-model="content.componenteCurricular"
                  label="Componente Curricular*"
                  outlined
                  dense
                  :items="componentesCurriculares"
                  item-value="id"
                  item-text="descricao"
                  return-object
                  :rules="[(v) => $required(v)]"
                ></v-select>
                <v-textarea
                  v-model="content.descricao"
                  label="O que é esperado do aluno*"
                  outlined
                  rows="4"
                  dense
                  counter="2500"
                  maxlength="2500"
                  :rules="[(v) => $required(v)]"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <div class="mt-4">
            <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
            <span>Os campos marcados com asterisco(*) são obrigatórios.</span>
          </div>
        </div>
        <sca-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="edit ? 'Editar' : 'Salvar'"
        ></sca-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { PerfilTurma } from '~/commons/classes/perfil-turma';
import PerfilTurmaService from '~/services/perfil-turma.service';

export default {
  props: {
    ...new DialogProps(PerfilTurma),
    titulo: {
      type: String,
      default: 'Perfil da Turma',
    },
    funcionalidade: {
      type: String,
      default: '',
    },
    componentesCurriculares: {
      type: Array,
      default: () => [],
    },
    niveisDeEnsino: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [PerfilTurmaService],
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja ${this.edit ? "editar" : "cadastrar"} o registro?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const perfilTurma = new PerfilTurma(this.content).format();
          return this.edit
            ? this.$editarPerfilTurma(this.funcionalidade, perfilTurma.id, perfilTurma)
            : this.$cadastrarPerfilTurma(this.funcionalidade, perfilTurma);
        });
      };
      if (this.$validarFormulario()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
  },
};
</script>
